import { Inject, Injectable } from "@angular/core";
import saveAs from 'file-saver';
import { LoadingController, Platform } from "ionic-angular";
import { AnalyticsProvider } from "../../providers/analytics/analytics";
import { FileDownloaderProvider } from "../../providers/file-downloader/file-downloader";
import { RequestPollingReportDto, RequestReportSendEmailExcelDto } from "../../shared/nestjs/gd-only/dto/survey-service.dto";
import { SurveyServiceV2NestApi } from "../../shared/nestjs/gd-only/services/survey-serviceV2-nest-api";
import { NestApiProvider } from "../../shared/nestjs/nest-api";
import { LoopBackAuth, SurveyServiceApi } from "../../shared/sdk";
import { SurveyServiceNestApi } from './../../shared/nestjs/gd-only/services/survey-service-nest-api';

@Injectable()
export class PollingReportBloc {
  isGoPathNew: Boolean;
  loading: any;
  requestBodyPolling: RequestPollingReportDto = new RequestPollingReportDto();
  requestSendEmail: RequestReportSendEmailExcelDto = new RequestReportSendEmailExcelDto();

  constructor(
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    private nestApiProvider: NestApiProvider,
    private platform: Platform,
    private fileDownloaderProvider: FileDownloaderProvider,
    private loadingCtrl: LoadingController,
    private analyticsProvider: AnalyticsProvider,
    private surveyServiceApi: SurveyServiceNestApi,
    private surveyServiceV2Api: SurveyServiceV2NestApi,
    private surveyServiceApiLb: SurveyServiceApi,
  ) {
  }

  async getSurveyLists(): Promise<any> {
    this.isGoPathNew = await this.nestApiProvider.isGoPathNewExist();
    if (this.isGoPathNew) {
      return new Promise(async (resolve, reject) => {
        let getSurvey = this.surveyServiceApi.getSurveyLists().subscribe(result => {
          resolve({ status: true, data: result })
        }, error => {
          reject(error.message)
        }, () => {
          getSurvey.unsubscribe()
        })
      })
    } else {
      return new Promise(async (resolve, reject) => {
        let getSurvey = this.surveyServiceApiLb.getSurveyLists().subscribe(result => {
          resolve({ status: true, data: result })
        }, error => {
          reject({ status: true })
        }, () => {
          getSurvey.unsubscribe()
        })
      })
    }
  }


  async downloadExcel(data) {
    this.isGoPathNew = await this.nestApiProvider.isGoPathNewExist();
    if (this.isGoPathNew) {
      this.requestBodyPolling.code = data.code;
      return await this.generateExcel(this.requestBodyPolling)
    } else {
      return await this.generateFileLB(data)
    }

  }

  generateExcel(data: RequestPollingReportDto): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.loader();
      let downloadExcel = this.surveyServiceV2Api.downloadExcel(data).subscribe(result => {
        if (this.platform.is('cordova')) {
          this.fileDownloaderProvider.downloadExcelBlob(result, 'Polling Report')
          resolve('Download successfully');
        } else {
          saveAs(result, 'Polling Report.xlsx')
          resolve('Download successfully');
        }
      }, error => {
        reject(error.message)
      }, () => {
        downloadExcel.unsubscribe()
        this.loading.dismiss();
      })

    })
  }

  private generateFileLB(data): Promise<any> {
    return new Promise(async (resolve, reject) => {

    });
  }


  async downloadPDF(data) {
    this.isGoPathNew = await this.nestApiProvider.isGoPathNewExist();
    if (this.isGoPathNew) {
      this.requestBodyPolling.code = data.code;
      return await this.generatePdf(this.requestBodyPolling)
    } else {
      return await this.generateFileLB(data);
    }
  }

  private generatePdf(data: RequestPollingReportDto): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.loader();
      let downloadExcel = this.surveyServiceV2Api.downloadPdf(data).subscribe(result => {
        if (this.platform.is('cordova')) {
          this.fileDownloaderProvider.downloadPdfBlob(result, 'Polling Report')
          resolve('Download successfully');
        } else {
          saveAs(result, 'Polling Report.pdf')
          resolve('Download successfully');
        }
      }, error => {
        reject(error.message)
      }, () => {
        downloadExcel.unsubscribe()
        this.loading.dismiss();
      })

    })
  }

  async sendMailExcel(data) {
    this.isGoPathNew = await this.nestApiProvider.isGoPathNewExist();
    this.requestSendEmail.code = data.code;
    this.requestSendEmail.emailTo = data.emailTo;
    this.requestSendEmail.fullName = data.fullName;
    return await this.sendEmailExcel(this.requestSendEmail)
  }

  async sendMailPdf(data) {
    this.requestSendEmail.code = data.code;
    this.requestSendEmail.emailTo = data.emailTo;
    this.requestSendEmail.fullName = data.fullName;
    return await this.sendEmailPdf(this.requestSendEmail)
  }

  private async sendEmailPdf(data: RequestReportSendEmailExcelDto): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.loader();
      let sendEmailPdf = this.surveyServiceV2Api.reportSendEmailPdf(data).subscribe(result => {
        resolve("Send Email Successfully")
      }, error => {
        reject(error.message);
      }, () => {
        this.loading.dismiss();
        sendEmailPdf.unsubscribe();
      })
    })
  }

  private async sendEmailExcel(data: RequestReportSendEmailExcelDto): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.loader();
      let sendEmailExcel = this.surveyServiceV2Api.reportSendEmailExcel(data).subscribe(result => {
        resolve("Send Email Successfully");
      }, error => {
        reject(error.message);
      }, () => {
        this.loading.dismiss();
        sendEmailExcel.unsubscribe();
      })
    })
  }

  loader(): void {
    this.loading = this.loadingCtrl.create();
    this.loading.present();
  }

}



// WEBPACK FOOTER //
// ./src/bloc/report/polling-report.bloc.ts